import { Tabs, TabsContent, TabsList, TabsTrigger } from '@ludus/ui'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { EditView } from '../EditView/EditView.tsx'
import { OverviewPlaceholder } from '../OverviewView/OverviewPlaceholder.tsx'

type TabKey = 'edit' | 'overview'

export function CalendarPage() {
  const { t } = useTranslation()
  const [tab, setTab] = useState<TabKey>('edit')

  return (
    <Tabs
      value={tab}
      onValueChange={(v) => setTab(v as TabKey)}
      className="-m-6 flex h-[calc(100%+3rem)] flex-col"
    >
      <header className="flex shrink-0 items-center justify-between gap-4 px-6 pt-6 pb-3">
        <div>
          <h1 className="text-xl font-semibold text-foreground">{t('nav.calendar')}</h1>
          <p className="mt-0.5 text-sm text-muted">{t('pages.calendar.description')}</p>
        </div>
        <TabsList>
          <TabsTrigger value="edit">{t('pages.calendar.tabs.edit')}</TabsTrigger>
          <TabsTrigger value="overview">{t('pages.calendar.tabs.overview')}</TabsTrigger>
        </TabsList>
      </header>

      <div className="flex flex-1 flex-col overflow-hidden px-6 pb-6">
        <TabsContent value="edit" className="animate-fade-in flex flex-1 overflow-hidden">
          <EditView />
        </TabsContent>
        <TabsContent value="overview" className="animate-fade-in flex flex-1 overflow-hidden">
          <OverviewPlaceholder />
        </TabsContent>
      </div>
    </Tabs>
  )
}
